import { HeadFlashOutlineIcon } from './HeadFlashOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 28D19749-AD74-4017-B4B1-AFA65AA7B47F
 * name head-flash-outline
 * version: 4.9.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/head-flash-outline.svg
 * tags
 */
export const HeadAcheOutlineIcon = HeadFlashOutlineIcon;
export default HeadAcheOutlineIcon